import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

/* Get the distinct, deduplicated Tag values across all recipients */
export const getTagOptions = async () => {
  const res = await get('/NotificationRecipient/TagOptions')
  return res.data
}

export const useGetTagOptions = () => {
  return useQuery(['emailAlertTagOptions'], getTagOptions, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

export default useGetTagOptions
